import React from 'react';
import DataDestinationsPage from 'dataSources/components/DataDestinationsPage';
import { useSelector } from 'react-redux';
import { getAdNetworks, getDataSourcesPage } from '../selector';

export default function UserLevelEtlPage() {
    const props = useSelector(state => getDataSourcesPage(state));
    const adnetworks = useSelector(state => getAdNetworks(state, 'USER_LEVEL'));
    const uansData = props.uansData?.filter(uan => Boolean(adnetworks[uan?.adnetworkName]));

    return <DataDestinationsPage redirectPath="react/user-level-etl" adnetworks={adnetworks} uansData={uansData} />;
}
